var _circle, _circle2, _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyLineFillTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#CCCCCC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 23.8368,
    cy: 23.837,
    r: 21.4369,
    fill: "#CCCCCC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0945,
    cy: 24.0941,
    rx: 18.3342,
    ry: 18.3342,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.285 17.2312L32.2849 17.2312C31.9868 17.2401 31.7038 17.3645 31.4956 17.578C31.4952 17.5784 31.4947 17.5789 31.4943 17.5794L20.6099 28.4637L16.0247 23.8785C15.9191 23.769 15.7929 23.6816 15.6532 23.6212L15.5541 23.8507L15.6532 23.6212C15.5128 23.5605 15.3617 23.5285 15.2087 23.5269C15.0557 23.5254 14.9039 23.5543 14.7623 23.6122C14.6206 23.67 14.4919 23.7555 14.3837 23.8637C14.2755 23.9719 14.19 24.1006 14.1322 24.2422C14.0744 24.3839 14.0454 24.5357 14.0469 24.6886C14.0485 24.8416 14.0806 24.9928 14.1413 25.1332C14.2016 25.2728 14.289 25.3991 14.3985 25.5047L19.7968 30.903L19.7968 30.903C20.0125 31.1186 20.305 31.2397 20.6099 31.2397C20.9149 31.2397 21.2073 31.1186 21.423 30.903L21.423 30.903L33.1205 19.2055C33.1209 19.2051 33.1214 19.2046 33.1218 19.2042C33.2873 19.0428 33.4003 18.8354 33.4461 18.6089C33.4921 18.3817 33.4683 18.146 33.378 17.9326C33.2877 17.7191 33.135 17.538 32.94 17.4128L32.8052 17.6228L32.94 17.4128C32.7449 17.2877 32.5166 17.2244 32.285 17.2312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLineFillTick);
export default __webpack_public_path__ + "static/media/grey-line-fill-tick.f76847a3ca0de0b328ab06db7d1b84c4.svg";
export { ForwardRef as ReactComponent };